import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import {
    DELETE_SDK ,
    DELETE_SDK_SUCCESS ,
    DELETE_SDK_FAIL,
} from '../../constants';

const deleteSDK = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_SDK),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.poiServer}/apps/delete`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.token}`,
        },
        body: action.data,
        responseType: 'json',
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {
          return {
            type: DELETE_SDK_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: DELETE_SDK_FAIL,
            error,
          })
        )
      )
    )
  );

export default deleteSDK;
